import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import SingleSelect from '@widgets/single-select';
import IconKanbanUser from '@shared/icons/IconKanbanUser';
import IconWrapper from '@shared/uikit/IconWrapper';
import { Tab, TabList } from '@widgets/tab';
import { keys } from 'lodash';
import Label from '@shared/uikit/label';
import ManagerInfo from '@pages/ManagersPerformance/components/ManagerInfo';
import CommandInfo from '@pages/ManagersPerformance/components/CommandInfo';
import { resolveHostingTabTitle } from '@pages/Hosting/Show/helpers/tabHelper';
import { setBreadcrumbs } from '@app/redux/features/breadcrumbsSlice';
import { BreadCrumbIcon, BreadCrumbType } from '@entities/util/IBreadCrumb';
import { IHosting } from '@entities/hosting/IHosting';
import { useHosting } from '@app/queries/hosting/useHosting';
import ValueWithSign from '@widgets/table/components/value-with-sign';
import { useHostingStatusOptions } from '@app/queries/options/useHostingStatusOptions';
import { ISelectOption } from '@widgets/multi-select';
import { GrayButton } from '@shared/uikit/button';
import IconDownload from '@shared/icons/IconDownload';
import PermissionGuard from '@shared/security/PermissionGuard';
import { CUSTOMER_PERMISSIONS } from '@app/contstants/permissions';
import DropdownButton from '@widgets/dropdown-button';
import IconVerticalThreeDots from '@shared/icons/IconVerticalThreeDots';
import { DeletePrompt } from '@widgets/prompt';
import { toast } from 'react-toastify';
import HostingInfoTab from '@pages/Hosting/Show/components/HostingInfoTab';
import HostingClientsTab from '@pages/Hosting/Show/components/HostingClientsTab';

export enum HostingTab {
  info = 'info',
  clients = 'clients',
}

const actions: ISelectOption[] = [{ value: 'remove', label: 'Удалить' }];

const HostingShow = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const hostingFetcher = useHosting();
  const statusesOptionsFetcher = useHostingStatusOptions();

  const [statusesOptions, setStatusesOptions] = useState<ISelectOption[]>();
  const [hosting, setHosting] = useState<IHosting | null>(null);
  const [activeTab, setActiveTab] = useState(0);
  const [isShowDelete, setShowDelete] = useState<boolean>(false);

  useEffect(() => {
    dispatch(
      setBreadcrumbs([
        {
          title: 'Хостинг',
          type: BreadCrumbType.LINK,
          link: '/hosting/main',
          icon: BreadCrumbIcon.HOSTING,
        },
        {
          title: 'Обзор хостингов',
          type: BreadCrumbType.LINK,
          link: '/hosting',
        },
        { title: 'Mining Capital', type: BreadCrumbType.TEXT },
      ])
    );
  }, []);

  useEffect(() => {
    (async () => {
      if (!id) return;

      const hosting = await hostingFetcher.fetch({ id: +id });
      setHosting(hosting);
    })();
  }, [id]);

  useEffect(() => {
    (async () => {
      const data = await statusesOptionsFetcher.fetch();
      setStatusesOptions(data);
    })();
  }, []);

  const onDelete = async () => {
    if (!id) return;

    try {
      // await deleteCustomerFetcher.fetch({ customerId: +id });
      //
      // setShowDeleteCustomers(false);
      toast.success('Хостинг успешно удален');

      navigate('/hosting/');
    } catch (e) {
      toast.error('Произошла ошибка при удалении');
    }
  };

  const handleAction = (value: string) => {
    switch (value) {
      case 'remove':
        setShowDelete(true);
        break;
      default:
        return;
    }
  };

  return (
    <>
      <div className="flex justify-between items-center w-full mb-[20px] pb-[20px] border-b border-[#211F24]">
        <div className="flex items-centerh-[36px] text-[20px]">
          <ValueWithSign value={hosting?.name} color="bg-[#4598E6]" />
        </div>
        <div className="flex gap-[10px] text-[14px] ">
          <div className="flex justify-end items-center gap-3">
            <Label title="Статус" textSize="14px" />
            <SingleSelect
              value={{ value: 'Активен', label: 'Активен' }}
              title="Статус"
              isLoading={!statusesOptionsFetcher.isSuccess}
              options={statusesOptions}
              onChange={value => {
                // @ts-ignore
              }}
              singleValueColor="#D7F525"
              textSize="16px"
              hideClearIcon={true}
            />
          </div>
          <GrayButton
            onClick={() => console.log()}
            title={
              <div className="flex gap-[10px] items-center fill-[white]">
                <IconDownload className="w-[11px] h-[14px] fill-[#D9D9D9]" />
              </div>
            }
          />
          <DropdownButton
            title={<IconVerticalThreeDots iconWithBorder={false} />}
            className="h-[33px] w-[15px]"
            options={actions}
            leftPx={-100}
            onSelect={(value: any) => {
              handleAction(value);
            }}
          />
        </div>
      </div>

      <TabList>
        {keys(HostingTab).map((key, index) => (
          <>
            <div className="text-[16px]">
              <Tab
                key={index}
                index={index}
                isActive={index === activeTab}
                label={resolveHostingTabTitle(key)}
                onClick={(index: number) => setActiveTab(index)}
              />
            </div>
          </>
        ))}
      </TabList>

      {0 === activeTab ? (
        <div className="mt-[25px]">
          <HostingInfoTab hosting={hosting} />
        </div>
      ) : null}

      {1 === activeTab ? (
        <div className="mt-[25px]">
          <HostingClientsTab />
        </div>
      ) : null}

      {isShowDelete ? (
        <DeletePrompt
          onClose={() => {
            setShowDelete(false);
          }}
          onSubmit={onDelete}
          open={true}
          title={<span className="text-[18px] text-[white] text-center">Удалить хостинг?</span>}
          subTitle={<>Хостинг будет удалён из базы данных.</>}
        />
      ) : null}
    </>
  );
};

export default HostingShow;
